webpackJsonp([35783957827783],{

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(48);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _SearchForm = __webpack_require__(75);
	
	var _SearchForm2 = _interopRequireDefault(_SearchForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'container' },
	    _react2.default.createElement(
	      'div',
	      { className: 'nav-left' },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { activeClassName: 'is-active', className: 'nav-item brand', to: '/' },
	        _react2.default.createElement('img', { alt: 'Frint', className: 'dark', src: '/img/frint-logo-7a7a7a.png' }),
	        _react2.default.createElement('img', { alt: 'Frint', className: 'light', src: '/img/frint-logo-fff.png' })
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { activeClassName: 'is-active', className: 'nav-item is-tab', to: '/docs' },
	        'Documentation'
	      ),
	      _react2.default.createElement(
	        'a',
	        { className: 'nav-item is-tab', href: 'https://medium.com/frintjs' },
	        'Blog'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { activeClassName: 'is-active', className: 'nav-item is-tab', to: '/repl' },
	        'REPL'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { activeClassName: 'is-active', className: 'nav-item is-tab', to: '/about' },
	        'About'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'nav-right' },
	      _react2.default.createElement(
	        'div',
	        { className: 'field nav-item' },
	        _react2.default.createElement(_SearchForm2.default, null)
	      )
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchForm = function (_Component) {
	  _inherits(SearchForm, _Component);
	
	  function SearchForm() {
	    _classCallCheck(this, SearchForm);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.state = { enabled: true };
	    return _this;
	  }
	
	  SearchForm.prototype.conponentWillMount = function conponentWillMount() {
	    if (typeof window === "undefined" || // eslint-disable-line no-undef
	    typeof window.docsearch === "undefined" // eslint-disable-line no-undef
	    ) {
	        console.warn("Search has failed to load and now is being disabled");
	        this.setState({ enabled: false });
	      }
	  };
	
	  SearchForm.prototype.componentDidMount = function componentDidMount() {
	    if (this.state.enabled) {
	      // eslint-disable-next-line no-undef
	      window.docsearch({
	        apiKey: "897a7279c47670a5c4b474ee84350387",
	        indexName: "frint.js",
	        inputSelector: "#doc-search-text-box",
	        debug: false
	      });
	    }
	  };
	
	  SearchForm.prototype.render = function render() {
	    var enabled = this.state.enabled;
	
	
	    return enabled ? _react2.default.createElement(
	      "p",
	      { className: "control has-icon" },
	      _react2.default.createElement("input", { className: "input", id: "doc-search-text-box", placeholder: "Search...", type: "text" }),
	      _react2.default.createElement(
	        "span",
	        { className: "icon is-small" },
	        _react2.default.createElement("i", { className: "fa fa-search" })
	      )
	    ) : null;
	  };
	
	  return SearchForm;
	}(_react.Component);
	
	exports.default = SearchForm;
	module.exports = exports["default"];

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(74);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'section',
	      { className: 'hero is-primary is-large' },
	      _react2.default.createElement(
	        'div',
	        { className: 'hero-head' },
	        _react2.default.createElement(
	          'header',
	          { className: 'nav' },
	          _react2.default.createElement(_Header2.default, null),
	          _react2.default.createElement(
	            'a',
	            { 'aria-label': 'View source on Github', className: 'github-corner', href: 'https://github.com/frintjs/frint' },
	            _react2.default.createElement(
	              'svg',
	              { 'aria-hidden': 'true', height: '80', style: { 'fill': '#151513', 'color': '#fff', 'position': 'absolute', 'top': 0, 'border': 0, 'right': 0 }, viewBox: '0 0 250 250', width: '80' },
	              _react2.default.createElement('path', { d: 'M0,0 L115,115 L130,115 L142,142 L250,250 L250,0 Z' }),
	              _react2.default.createElement('path', { className: 'octo-arm', d: 'M128.3,109.0 C113.8,99.7 119.0,89.6 119.0,89.6 C122.0,82.7 120.5,78.6 120.5,78.6 C119.2,72.0 123.4,76.3 123.4,76.3 C127.3,80.9 125.5,87.3 125.5,87.3 C122.9,97.6 130.6,101.9 134.4,103.2', fill: 'currentColor', style: { 'transformOrigin': '130px 106px' } }),
	              _react2.default.createElement('path', { className: 'octo-body', d: 'M115.0,115.0 C114.9,115.1 118.7,116.5 119.8,115.4 L133.7,101.6 C136.9,99.2 139.9,98.4 142.2,98.6 C133.8,88.0 127.5,74.4 143.8,58.0 C148.5,53.4 154.0,51.2 159.7,51.0 C160.3,49.4 163.2,43.6 171.4,40.1 C171.4,40.1 176.1,42.5 178.8,56.2 C183.1,58.6 187.2,61.8 190.9,65.4 C194.5,69.0 197.7,73.2 200.1,77.6 C213.8,80.2 216.3,84.9 216.3,84.9 C212.7,93.1 206.9,96.0 205.4,96.6 C205.1,102.4 203.0,107.8 198.3,112.5 C181.9,128.9 168.3,122.5 157.7,114.1 C157.9,116.9 156.7,120.9 152.7,124.9 L141.0,136.5 C139.8,137.7 141.6,141.9 141.8,141.8 Z', fill: 'currentColor' })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'hero-body' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container has-text-centered' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'title' },
	            'Modular ',
	            _react2.default.createElement(
	              'span',
	              null,
	              'JavaScript'
	            ),
	            ' framework',
	            _react2.default.createElement('br', null),
	            'for building ',
	            _react2.default.createElement(
	              'span',
	              null,
	              'Scalable'
	            ),
	            ' & ',
	            _react2.default.createElement(
	              'span',
	              null,
	              'Reactive'
	            ),
	            ' applications.'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'a',
	              { className: 'button is-primary is-medium', href: '/docs' },
	              'Learn more'
	            ),
	            _react2.default.createElement(
	              'a',
	              { className: 'button is-transparent is-medium', href: 'http://github.com/frintjs/frint' },
	              'GitHub'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'section about' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'column' },
	            _react2.default.createElement('img', { alt: 'Modular', src: '/img/js-logo.png' }),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Modular & Extensible'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'The whole framework is split into multiple independent packages. You get to compose your Apps with only the packages your need.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'column' },
	            _react2.default.createElement('img', { alt: 'Component', src: '/img/react-logo.svg' }),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Component-Based'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'You can roll your own Component based view libraries with Frint. We have official support for React.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'column' },
	            _react2.default.createElement('img', { alt: 'Reactive', src: '/img/rxjs-logo.png' }),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Reactive Development'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'We embraced the power of reactive programming everywhere, including app-to-app communication for ease of development.'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'section apps' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Split your application across multiple apps'
	        ),
	        _react2.default.createElement('img', { alt: 'apps', src: '/img/frint-apps.png' }),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Learn how to write ',
	          _react2.default.createElement(
	            'a',
	            { href: '/guides/apps' },
	            ' Root Apps & Child Apps '
	          ),
	          'targeting different ',
	          _react2.default.createElement(
	            'a',
	            { href: '/guides/regions' },
	            'Regions'
	          ),
	          '.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'section regions' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Load apps coming in from separate bundles'
	        ),
	        _react2.default.createElement('img', { alt: 'apps', src: '/img/frint-code-splitting.png' }),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Learn more about',
	          _react2.default.createElement(
	            'a',
	            { href: '/guides/apps' },
	            ' Apps'
	          ),
	          ' and',
	          _react2.default.createElement(
	            'a',
	            { href: '/guides/regions' },
	            ' Regions'
	          ),
	          ', and',
	          _react2.default.createElement(
	            'a',
	            { href: '/guides/code-splitting' },
	            ' Code Splitting'
	          ),
	          '.'
	        )
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-6ec044e1e5f2e5977fd2.js